import React, { useContext, useEffect, useState } from 'react'
import { MapContext } from '../../component'
import mapboxgl from 'mapbox-gl'
import PitchToggle from './_pitchcontrol/pitchtogglecontrol'
export const PitchControl = ({
  options = { bearing: 0, pitch: 60 },
  position,
  getControl
}: {
  options?: {
    bearing?: number
    pitch?: number
    minpitchzoom?: null | undefined
  }
  position?: controlPositions
  getControl?: (a: PitchToggle) => void
}) => {
  const map = useContext(MapContext)
  const [control, setControl] = useState<PitchToggle | null>(null)

  useEffect(() => {
    if (!map) return
    if (control) map.removeControl(control)
    const newcontrol = new PitchToggle(options)
    map.addControl(newcontrol, position)
    if (getControl) getControl(newcontrol)
    setControl(newcontrol)
  }, [])
  return null
}
